import React, { ChangeEvent } from 'react';
import SelectField from '../../../../../../../components/SelectField';
import {
    IContract,
    IContractItem,
} from '../../../../../../../models/customerService';
import {
    selectPane,
    TTasksPaneTypes,
} from '../../../../../../../state/ui/customerService/pane/tasksPane';
import { useSelectedPane } from '../../../../../../../state/ui/customerService/pane/tasksPane/index.hooks';
import { useTaskPaneLoading } from '../../../../../../../state/ui/customerService/bottomGrid/tasks/index.hooks';
import { useToolkitDispatch } from '../../../../../../../hooks';

interface IOwnProps {
    contract?: IContract;
    contractItem?: IContractItem;
}
export const SelectPane = ({ contract, contractItem }: IOwnProps) => {
    const toolkitDispatch = useToolkitDispatch();

    const selectedTaskPane = useSelectedPane();
    const paneLoading = useTaskPaneLoading();

    const handleTasksPaneChange = (e: ChangeEvent<HTMLInputElement>) => {
        toolkitDispatch(selectPane(e.target.value as TTasksPaneTypes));
    };
    const paneTypes: TTasksPaneTypes[] = ['Task'];
    if (contractItem) {
        paneTypes.push('ContractItem');
    }
    if (contract) {
        paneTypes.push('Contract');
    }
    paneTypes.push('Client', 'Location');

    return (
        <SelectField
            name="selectPane"
            value={selectedTaskPane || 'Task'}
            ids={paneTypes}
            handleChange={handleTasksPaneChange}
            disabled={paneLoading}
        />
    );
};
